import React from 'react';
import styles from './ListHeader.module.scss';

function ListHeader(props) {
    const {className = '', children} = props;

    return (
        <div className={[className, styles.ListHeader].join(' ')}>
            <h3
                style={{
                    paddingLeft: '1em',
                }}>
                {children}
            </h3>
            <hr className="thin" />
        </div>
    );
}

export default ListHeader;
